'use client';

import { CC_PAID_ROUNDUP_AO_PAGE_NAME } from '@cc-shopping/contracts/credit-cards-page/constants';
import { useAnalyticsPageView } from '@cc-shopping/platform-analytics/AnalyticsPageView/Context';

export function useIsApprovalOddsPage() {
  const { pageName } = useAnalyticsPageView();
  return pageName === CC_PAID_ROUNDUP_AO_PAGE_NAME;
}
